import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { GetIdByIndex, ProductById, ProductByNAME, ProductInitialsByNAME, ProductListInitials } from 'src/app/data/products';
import { RestService } from '../rest/rest.service';

const EXCELcollumns = [
  'Carga',
  'Albaran',
  'Fecha',
  'Hora',
  'Cliente',
  'Serie Factura',
  'Equipo',
  'No Pagado',
  'Pagado',
  'Comentario',
  'Productos'
];
const EXCELpadding = ['', '', '', '', '', '', '', '', '', '', '', '', ''];
let arrayProductsTotals = Array(ProductListInitials.length).fill(0);

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  constructor(private rest: RestService) { }

  async generateExcel(data) {
    let sheetData = [];

    sheetData = await this.excelCreateBlock(data.albaranes, sheetData);

    sheetData = await this.excelCreateResume(data, sheetData);

    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData);

    ws['!cols'] = [
      { wch: 6 },
      { wch: 7 },
      { wch: 10 },
      { wch: 6 },
      { wch: 35 },
      { wch: 10 },
      { wch: 10 },
      { wch: 15 },
      { wch: 10 },
      { wch: 5 },
      { wch: 10 },
      { wch: 10 },
      { wch: 8 },
      { wch: 7 },
      { wch: 4 },
      { wch: 4 },
      { wch: 4 },
      { wch: 4 },
      { wch: 4 },
      { wch: 4 },
      { wch: 4 },
      { wch: 4 }
    ];

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, new Date().toDateString());

    /* save to file */

    XLSX.writeFile(wb, data.firstName + this.getDateFormated() + '.xlsx');
    arrayProductsTotals = Array(ProductListInitials.length).fill(0);
    console.log('created');
  }

  async excelCreateBlock(data, table) {
    const newTable = table;
    const excelCols = [...EXCELcollumns];
    excelCols.splice(5, 1);
    newTable.push(excelCols.concat(ProductListInitials));
    let totalPromo = 0;
    // for (let i = 0; i < data.length; i++) {
    for (const iterator of data) {
      // for (let j = 0; j < data[i].length; j++) {
      for (const element of iterator) {
        // const element = data[i][j];
        if (element && element.cliente) {
          let noPagado = 0; // (element.cliente.paga !== '' && element.cliente.paga) ? 0 : element.total;
          let Pagado = 0; // (element.cliente.paga !== '' && element.cliente.paga) ? element.total : 0;
          if (element.cliente.paga === true &&
            (element.cliente.facturaMensual && element.cliente.facturaMensual === true)
          ) {
            Pagado += element.totalWithIva ? element.totalWithIva : element.total;
          } else if (element.cliente.paga === true && !element.cliente.facturaMensual) {
            Pagado += element.total;
          } else if (element.cliente.paga === false &&
            (element.cliente.facturaMensual && element.cliente.facturaMensual === true)) {
            noPagado += element.totalWithIva ? element.totalWithIva : element.total;
          } else if (element.cliente.paga === false && !element.cliente.facturaMensual) {
            noPagado += element.total;
          }

          const date = new Date(element.fecha);
          const fecha = this.getDateFormated(date);
          const fechaTime = ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + '';
          const team = [{id:1, name: 'IBERICA DE HIELO'},{ id:2, name: 'La confianza'},
                        {id:3, name: 'Boden Ice S.L.'},  { id:4,   name: 'ARTE HIELO ESCULTURAS SL.' },
                        {id:5, name: 'ICE VENTURE SL.' }]
          const teamName = team.find((e) => e.id === element.cliente.team)
          const initialColumns = [
            element.cargaNumber,
            element.id,
            fecha,
            fechaTime,
            element.cliente.nombre,
            teamName ? teamName.name : null,
            noPagado,
            Pagado,
            element.comment,
            this.parseProductExcel(element)
          ];
          const productsColumns = this.parseProductExcelSingleColumn(element);
          newTable.push(initialColumns.concat(productsColumns));
        }
        if (element && element.regalos) {
          totalPromo += element.regalos.length;
        }
      }
    }

    const emptyStart = Array(8).fill('');
    newTable.push(emptyStart.concat(['Total']).concat(arrayProductsTotals));
    newTable.push(emptyStart.concat(['Total Promicion']).concat(totalPromo));
    return newTable;
  }

  parseProductExcelObject(productsArray, currentList = [], chino = null) {
    const productsList = currentList.length > 0 ? currentList : [];
    if (Array.isArray(productsArray)) {
      productsArray.forEach(products => {
        if (products && products.cantidad) {
          products.cantidad.forEach((product, index) => {
            // const idP = product.product;
            const prod = ProductById(product.product ? product.product : GetIdByIndex(index));
            if (prod) {
              const n = this.parseProductName(prod);
              if (chino && products.cliente && products.cliente.chino) {
                if (!productsList[n]) {
                  productsList[n] = { p: n, q: 0, chino: true };
                }
                productsList[n].q += product.unit;
                // productsList[n].chino = true;
              } else if (!chino && products.cliente && !products.cliente.chino) {
                if (!productsList[n]) {
                  productsList[n] = { p: n, q: 0, chino: false };
                }
                productsList[n].q += product.unit;
                // productsList[n].chino = false;
              }
            }
          });
        }
      });
    } else {
      productsArray.cantidad.forEach((product, index) => {
        const idP = product.product ? product.product : GetIdByIndex(index);
        const prod = ProductById(idP);
        if (prod) {
          const n = this.parseProductName(prod);
          if (!productsList[n]) {
            productsList[n] = { p: n, q: 0, chino: productsArray.cliente.chino };
          }
          productsList[n].q += product.unit;
          productsList[n].chino = productsArray.cliente.chino;
        }
      });
    }
    return productsList;
  }

   parseProductName(name){
    if (name === 'CUBO 5X5'){
      return 'CB5X5'
    }
    else if (name === 'LINGOTE 4X12'){
      return 'LN4X12'
    }
    else if (name === 'ESFERAS 6CM'){
      return 'ES6'
    }
    else if (name === 'CUBO 5,5 X 5,5'){
      return 'CB5,5'
    }
    else if (name === 'CUBO 5X7'){
      return 'CB5X7'
    }
    else if (name === 'LINGOTE 3X15'){
      return 'LN3X15'
    }
    else if (name === 'ESFERAS 3CM'){
      return 'ES3'
    }
    else if (name === 'BARRA'){
      return 'BA'
    }
    else if (name === 'BLOQUES'){
      return 'BL'
    }
    else{
     return name.match(/\b(\w)/g).join('');
    }
  }

  parseProductExcel(products) {
    const productsList = this.parseProductExcelObject(products);
    let productsString = '';
    Object.keys(productsList).forEach(key => {
      if (productsList[key].q > 0)
        productsString =
          productsString + productsList[key].q + '' + productsList[key].p + ' ';
    });
    return productsString;
  }

  parseProductExcelSingleColumn(products) {
    const productsList = this.parseProductExcelObject(products);
    // let productsString = '';
    const listSize = productsList.length;
    const arrayProducts = Array(listSize).fill('');
    Object.keys(productsList).forEach(key => {
      if (productsList[key].q > 0) {
        ProductListInitials.forEach((keyList, index) => {
          if (keyList === productsList[key].p) {
            arrayProducts[index] = productsList[key].q;
            arrayProductsTotals[index] += productsList[key].q;
          } else {
            arrayProducts[index] = arrayProducts[index] ? arrayProducts[index] : ' ';
            arrayProductsTotals[index] = arrayProductsTotals[index] ? arrayProductsTotals[index] : 0;
          }
        });
      }
      // productsString =
      //   productsString + productsList[key].q + '' + productsList[key].p + ' ';
    });

    return arrayProducts;
  }

  getDateFormated(date = new Date()) {
    const yefecha = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    const mofecha = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
    const dafecha = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
    return `${dafecha}/${mofecha}/${yefecha}`;
  }

  async excelCreateResume(data, table) {
    const newTable = table;
    newTable.push(EXCELpadding);
    newTable.push(EXCELpadding);
    newTable.push([
      '',
      '',
      '',
      '',
      '',
      'Dinero No Pagado',
      'Dinero Pagado',
      'Productos'
    ]);
    let totalChino = 0;
    let totalChinoNoPagado = 0;
    let totalChinoP = '';
    let totalHotelaria = 0;
    let totalHotelariaNoPagado = 0;
    let totalHotelariaP = '';
    let totalPagado = 0;
    let totalNoPagado = 0;
    let totalP = '';

    const totalChinoArray = {};
    const totalArray = {};
    const totalHotelariaArray = {};

    let currentListChino = [];
    let currentListNoChino = [];
    let currentList = [];
    const pagado = this.parseTotalValueExcel(data.albaranes, true);
    const noPagado = this.parseTotalValueExcel(data.albaranes, false);

    totalChino += pagado[0];
    totalHotelaria += pagado[1];
    totalChinoNoPagado += noPagado[0];
    totalHotelariaNoPagado += noPagado[1];
    totalPagado = totalChino + totalHotelaria;
    totalNoPagado = totalChinoNoPagado + totalHotelariaNoPagado;

    data.albaranes.forEach(elem => {
      currentListChino = this.parseProductExcelObject(elem, currentListChino, true);
      console.log(currentListChino);

      Object.keys(currentListChino).forEach(key => {
        if (currentListChino[key].q > 0) {
          if (currentListChino[key].chino) {
            if (!totalChinoArray[currentListChino[key].p])
              totalChinoArray[currentListChino[key].p] = 0;
            totalChinoArray[currentListChino[key].p] += currentListChino[key].q;
          } else {
            if (!totalHotelariaArray[currentListChino[key].p])
              totalHotelariaArray[currentListChino[key].p] = 0;
            totalHotelariaArray[currentListChino[key].p] += currentListChino[key].q;
          }
          if (!totalArray[currentListChino[key].p])
            totalArray[currentListChino[key].p] = 0;
          totalArray[currentListChino[key].p] += currentListChino[key].q;
        }
      });
      currentListNoChino = this.parseProductExcelObject(elem, currentListNoChino, false);
      console.log(currentListNoChino);

      Object.keys(currentListNoChino).forEach(key => {
        if (currentListNoChino[key].q > 0) {
          if (currentListNoChino[key].chino) {
            if (!totalChinoArray[currentListNoChino[key].p])
              totalChinoArray[currentListNoChino[key].p] = 0;
            totalChinoArray[currentListNoChino[key].p] += currentListNoChino[key].q;
          } else {
            if (!totalHotelariaArray[currentListNoChino[key].p])
              totalHotelariaArray[currentListNoChino[key].p] = 0;
            totalHotelariaArray[currentListNoChino[key].p] += currentListNoChino[key].q;
          }
          if (!totalArray[currentListNoChino[key].p])
            totalArray[currentListNoChino[key].p] = 0;
          totalArray[currentListNoChino[key].p] += currentListNoChino[key].q;
        }
      });
    });
    Object.keys(totalArray).forEach(key => {
      totalP = totalP + (totalArray[key] + '' + key + ' ');
    });
    Object.keys(totalHotelariaArray).forEach(key => {
      totalHotelariaP =
        totalHotelariaP + (totalHotelariaArray[key] + '' + key + ' ');
    });
    Object.keys(totalChinoArray).forEach(key => {
      totalChinoP = totalChinoP + (totalChinoArray[key] + '' + key + ' ');
    });

    currentList = [];
    if (data.cargas.length > 0) {
      newTable.push([
        '',
        '',
        '',
        '',
        'Suma Chino',
        parseFloat(totalChinoNoPagado.toFixed(2)),
        parseFloat(totalChino.toFixed(2)),
        totalChinoP
      ]);
      newTable.push([
        '',
        '',
        '',
        '',
        'Suma hostelaria',
        parseFloat(totalHotelariaNoPagado.toFixed(2)),
        parseFloat(totalHotelaria.toFixed(2)),
        totalHotelariaP
      ]);
      newTable.push(EXCELpadding);
      newTable.push([
        '',
        '',
        '',
        '',
        'Total',
        parseFloat(totalNoPagado.toFixed(2)),
        parseFloat(totalPagado.toFixed(2)),
        totalP
      ]);
      newTable.push(EXCELpadding);
      
      newTable.push([
        'Fecha',
        this.getDateFormated(new Date(data.cargas[0].acceptedAt)),
        'Repartidor',
        data.user.firstName + (data.user.dni ? ('-' + data.user.dni) : '')
      ]);
      newTable.push(EXCELpadding);
      newTable.push([
        'Carga nº',
        'Lote',
        'Matricula',
        'Cargadas',
        'Devolver',
        '',
        '',
        '',
        '',
        '',
        'Fecha inicio',
        'Hora inicio',
        'Fecha fin',
        'Hora fin'
      ]);
    } else {
      newTable.push([
        '',
        '',
        '',
        '',
        'Total',
        (totalHotelaria + totalChino).toFixed(2),
        '',
        totalP
      ]);
    }

    let cargaNum = 1;
    for (const carga of data.cargas) {
      const firstC = carga;
      let productList = '';
      for (const productEntry of carga.product) {
        if (productEntry.unit > 0) {
          const shortName = ProductById(productEntry._id)
            .match(/\b(\w)/g)
            .join('');
          productList += productEntry.unit + shortName + ' ';
        }
      }

      const car: any = await this.rest.generalGetById('cars', carga.car);
      const dateIni = new Date(carga.acceptedAt);
      const showIniDate = `${('0' + dateIni.getDate()).slice(-2)}/${('0' + (dateIni.getMonth() + 1)).slice(-2)}`;
      const showIniTime = `${('0' + dateIni.getHours()).slice(-2)}:${('0' + dateIni.getMinutes()).slice(-2)}`;
      const dateFin = new Date(carga.closedAt);
      const showFinDate = `${('0' + dateFin.getDate()).slice(-2)}/${('0' + (dateFin.getMonth() + 1)).slice(-2)}`;
      const showFinTime = `${('0' + dateFin.getHours()).slice(-2)}:${('0' + dateFin.getMinutes()).slice(-2)}`;
      console.log(carga);
      newTable.push([
        cargaNum,
        carga.lote,
        car.body.matricula,
        productList,
        carga.furgoneta.units,
        '',
        '',
        '',
        '',
        '',
        showIniDate,
        showIniTime,
        showFinDate,
        showFinTime
      ]);
      cargaNum += 1;
    }

    return newTable;
  }

  parseTotalValueExcel(albarans, pagado) {
    let totalChino = 0;
    let totalHotelaria = 0;

    for (const albaranBlock of albarans) {
      for (const albaran of albaranBlock) {
        if (albaran && albaran.cliente && albaran.cliente.paga === pagado) {
          if (albaran.cliente.chino === true) {
            if (
              albaran.cliente.facturaMensual &&
              albaran.cliente.facturaMensual === true
            ) {
              totalChino += albaran.totalWithIva ? albaran.totalWithIva : albaran.total;
            } else {
              totalChino += albaran.total;
            }
          } else {
            if (
              albaran.cliente.facturaMensual &&
              albaran.cliente.facturaMensual === true
            ) {
              totalHotelaria += albaran.totalWithIva ? albaran.totalWithIva : albaran.total;
            } else {
              totalHotelaria += albaran.total;
            }
          }
        }
      }
    }

    return [totalChino, totalHotelaria];
  }

  async createMonthSession(records, year, month) {
    let sheetData = [];

    sheetData = await this.createLines(records, sheetData);
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, new Date().toDateString());

    /* save to file */

    XLSX.writeFile(wb, year + '/' + month + ' - ' + this.getDateFormated() + '.xlsx');
    arrayProductsTotals = Array(ProductListInitials.length).fill(0);
    console.log('created');
  }

  async createYearSession(records, year) {
    let sheetData = [];

    sheetData = await this.createLines(records, sheetData);
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, new Date().toDateString());

    /* save to file */

    XLSX.writeFile(wb, year + '/' + ' - ' + this.getDateFormated() + '.xlsx');
    arrayProductsTotals = Array(ProductListInitials.length).fill(0);
    console.log('created');
  }

  createLines(records, table) {
    const newTable = table;
    newTable.push(EXCELcollumns.concat(ProductListInitials).concat(['Tarifas']));

    for (const element of records) {
      if (element.cliente) {
        let noPagado = 0; // (element.cliente.paga !== '' && element.cliente.paga) ? 0 : element.total;
        let Pagado = 0; // (element.cliente.paga !== '' && element.cliente.paga) ? element.total : 0;
        // if (element.cliente.nombre === 'CHALET PINAR 17') {
        //   console.error('cliente: ', element.cliente.nombre);
        // } else {
        //   console.log('cliente: ', element.cliente.nombre);
        // }
        // console.log('totalWithIva: ', element.totalWithIva);
        // console.log('total: ', element.total);
        // console.log('paga: ', element.cliente.paga);
        // console.log('facturaMensual: ', element.cliente.facturaMensual);
        
        

        if (element.cliente.paga === true) {
          Pagado += element.totalWithIva ? element.totalWithIva : element.total;
        } else {
          noPagado += element.totalWithIva ? element.totalWithIva : element.total;
        }
        // if (element.cliente.paga === true &&
        //   (element.cliente.facturaMensual && element.cliente.facturaMensual === true)
        // ) {
        //   Pagado += element.totalWithIva ? element.totalWithIva : element.total;
        // } else if (element.cliente.paga === true && !element.cliente.facturaMensual) {
        //   Pagado += element.total;
        // } else if (element.cliente.paga === false &&
        //   (element.cliente.facturaMensual && element.cliente.facturaMensual === true)) {
        //   noPagado += element.totalWithIva ? element.totalWithIva : element.total;
        // } else if (element.cliente.paga === false && !element.cliente.facturaMensual) {
        //   noPagado += element.total;
        // }

        const date = new Date(element.fecha);
        const fecha = this.getDateFormated(date);
        const fechaTime = ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + '';
        const team = [{id:1, name: 'IBERICA DE HIELO'},{ id:2, name: 'La confianza'},
                      {id:3, name: 'Boden Ice S.L.'},  { id:4,   name: 'ARTE HIELO ESCULTURAS SL.' },
                      {id:5, name: 'ICE VENTURE SL.'}]
        const teamName = team.find((e) => e.id === element.cliente.team)
        let strTarifas = '';
        if (element.cliente.tarifa) {
          element.cliente.tarifa.forEach(tarifa => {
            strTarifas += ` • ${ProductInitialsByNAME(tarifa.product)} (${tarifa.name} - ${tarifa.price} ${tarifa.ivaRequered ? `- IVA ${tarifa.iva}` : ''})`
          });
        }

        const initialColumns = [
          (element.empleado ? element.empleado.firstName : 'firstName') + ' ' + (element.empleado ? element.empleado.lastName : 'lastName') + ' - ' + (element.empleado ? element.empleado.dni : ''),
          element.id,
          fecha,
          fechaTime,
          element.cliente.nombre,
          element.cliente.seriefacturaId || '-',
          teamName ? teamName.name : null,
          noPagado,
          Pagado,
          element.comment,
          this.parseProductExcel(element)
        ];
        const productsColumns = this.parseProductExcelSingleColumn(element);
        newTable.push(initialColumns.concat(productsColumns).concat([strTarifas]));
      } else {
        console.log(element);
        console.log(element.cliente);
      }
    }

    return newTable;
  }

  async createMonthFacturas(records, year, month) {
    let sheetData = [];

    sheetData = await this.createFacturasLines(records, sheetData);
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, new Date().toDateString());

    /* save to file */

    XLSX.writeFile(wb, year + '/' + month + ' - ' + this.getDateFormated() + '.xlsx');
    arrayProductsTotals = Array(ProductListInitials.length).fill(0);
    console.log('created');
  }

  createFacturasLines(records, table) {
    const newTable = table;
    newTable.push(['Serie', 'Numero de factura', 'Cliente', 'Documento', 'Fecha', 'Importe']);

    for (const element of records) {
      const initialColumns = [
        element.serie,
        element.id,
        element.nombre,
        element.documento,
        this.getDateFormated(new Date(element.fecha)),
        element.total
      ];

      newTable.push(initialColumns);
    }

    return newTable;
  }
}
